(function () {
  var homeSwiper = null;

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function init() {
    var el = document.querySelector(".homeSlider");
    if (!el || typeof Swiper === "undefined") return;

    var originalSlidesCount = el.querySelectorAll(".swiper-slide").length;

    var mobile = isMobile();
    var perView = mobile ? 1 : 3;

    // ループ条件は余裕を持たせる
    var loop = originalSlidesCount >= (perView + 1);

    if (homeSwiper && homeSwiper.destroy) {
      homeSwiper.destroy(true, true);
      homeSwiper = null;
    }

    homeSwiper = new Swiper(el, {
      slidesPerView: perView,

      // いったん維持。次の案でここを切り替える
      spaceBetween: mobile ? 0 : 8,


      loop: loop,
      watchOverflow: true,

      loopedSlides: originalSlidesCount,
      loopAdditionalSlides: originalSlidesCount,

      // ズレ対策
      roundLengths: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,

      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev")
      },

      on: {
        imagesReady: function () {
          this.update();
          this.slideToLoop(this.realIndex, 0, false);
        },
        resize: function () {
          this.update();
          this.slideToLoop(this.realIndex, 0, false);
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);

  var resizeTimer = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });
})();
